import { Injectable } from '@angular/core';
import { BaseService, ContentTypeEnum } from './base.service';
import { Cart, CartRequest, CheckoutReq, CheckoutReqGT } from '../models/cart';

@Injectable({
  providedIn: 'root',
})
export class CartService extends BaseService {
  addToCart(
    productCode: string,
    uom: string,
    quantity: number,
    category: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const cartRequest = {
      code: productCode,
      uom: uom,
      quantity: quantity,
      product_category: category,
    };

    this.post('/cart', cartRequest).subscribe(
      (resp) => {
        console.log('resp', resp)
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          // onError(resp.alert.message);
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  putToCart(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const data = { data: param };
    this.put('cart', data).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  updateQuantity(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const data = param;
    this.put('cart/update-quantity', data).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getCart(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('cart').subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getTotalCart(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/cart/total').subscribe(
      (resp) => {
        onSuccess(resp.data);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  checkoutPreview(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get('checkout/preview').subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  delete(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const postData = { ids: param };

    this.post('cart/delete', postData).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  checkout(
    param: CheckoutReq,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const formData = new FormData();

    formData.append('RequestId', param.RequestId);
    formData.append('PurchaseOrderNumber', param.PurchaseOrderNumber);
    formData.append('ShipToPartyCode', param.ShipToPartyCode);
    formData.append('CheckoutMethod', '1');
    if (param.Pin !== '' && param.Pin !== undefined) {
      formData.append('Pin', param.Pin);
    }
    formData.append('File', param.File);

    this.postMultipartFormData('v3/checkout', formData).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  checkoutGt(
    param: CheckoutReqGT,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const formData = new FormData();

    formData.append('descriptionSp', param.PurchaseOrderNumber);
    formData.append('address', param.Address);
    formData.append('shipToPartyCode', param.ShipToPartyCode);
    // if (param.Pin !== '' && param.Pin !== undefined) {
    //   formData.append('pin', param.Pin);
    // }
    formData.append('fileSp', param.File);

    this.postGtMultipartFormData('/api/v5/checkout', formData).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  statusClosing(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get('v2/ezrx/status-closing').subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  updateCartPromo(
    objRequest: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.postPromo('v1/Order/simulate-order', objRequest).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
